import React from "react";

export default function LastMonthTotalSales({ lastMonthsTotalSale }) {
  return (
    <p className="fs-85 marq grey">
      Geçen ay {lastMonthsTotalSale}+ Kez sipariş edildi
    </p>
  );
}
